@if (loading === true) {
  <div class='loader'>
    <div class='spinner'>
      <div class='container'>
        <div class='hex0'></div>
        <div class='hex120'></div>
        <div class='hex240'></div>
      </div>
    </div>
  </div>
}
@if (wire && productGroup) {
  @if (wire.show_banner) {
    <div class="banner-container">
      <img class="banner" [src]="productGroup.branding.banner_s3_url" alt="Branding banner"/>
    </div>
  }
  @if (loading === false) {
    <div class="wrapper">
      <div class="brand">
        @if (brandingPG) {
          <div class="brand-image" [class.no-brand]="brandingPG.name === 'all' && !wire.branding">
            <img [src]="brandingPG.branding.icon_s3_url"/>
          </div>
        }
        <div class="brand-name">
          <h3>{{brandingPG?.name}}</h3>
          <p>{{dateCreated | date:'short'}}</p>
        </div>
        <div class="brand-options">
          <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
        </div>
      </div>
      @if (wire['media_type']) {
        <div class="{{mediaClasses}}" [style.background-image]="videoPlaceholderUrl">
          @if (wire['media_type'] === 'image' && wire['image_url']) {
            <img class="media-image" [src]="wire['image_url']"/>
          }
          @if (!showPdfMarkup && wire['media_type'] === 'video' && wire['video_url']) {
            <app-video [videoUrl]="wire['video_url']"></app-video>
          }
          @if (showPdfMarkup && wire['media_type'] === 'video') {
            <div class="media-placeholder">{{videoShortname}}</div>
          }
        </div>
      }
      <div class="card-phone-summary" [innerHtml]="wire['text'] | safeHtml">
      </div>
      <div class="actions">
        @for (action of wire['actions']; track action; let i = $index) {
          <div (click)="doAction(action, $event)">
            @if (action.type !== 'consent_upgrade' && action.type !== 'disclaimer' && !(action.type === 'two_way' && !twoWayService.showTwoWay())) {
              <div class="action">
                @if (showPdfMarkup) {
                  <span class='action-number'>{{i + 1}}</span>
                }
                <div id="step-action-{{action.id}}">
                  @if (action.type === 'hyperlink') {
                    <a class="action-text hyperlink-action" href="{{action.value}}" target="_blank">{{action.label}}</a>
                  }
                  @if (action.type === 'call') {
                    <a class="action-text call-action" href="tel:{{action.value}}">{{action.label}}</a>
                  }
                  @if (action.type === 'email') {
                    <a class="action-text email-action"
                    href="mailto:{{action['value']}}?subject={{action['label']}}">{{action.label}}</a>
                  }
                  @if (action.type === 'collapsible') {
                    <span class="action-text collapsible-action">
                      {{action.label}}
                    </span>
                  }
                  @if (isSimpleAction(action)) {
                    <span class="action-text message-action">
                      {{action.label}}
                    </span>
                  }
                  @if (action.type === 'message' && isJourneyPreview) {
                    <span class="step-action">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width='58' height='90'>
                        <g transform="translate(35, 52)">
                          <path d="M 20,11 5,20 5,3 z"/>
                        </g>
                        <line class="top-line" x1="24" y1="0"
                          stroke-width="2"/>
                        <line class="down-line" x1="25" x2="25" y1="68" y2="0"
                          stroke-width="2"/>
                        <line class="bottom-line" id="" x1="12" y1="0"
                          stroke-width="2"/>
                      </svg>
                    </span>
                  }
                </div>
                @if (action.show !== true) {
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                }
                @if (action.show === true) {
                  <i class="fa fa-angle-down" aria-hidden="true"></i>
                }
              </div>
            }
            @if (action.type === 'collapsible') {
              <div class="collapsible-content" [ngClass]="{'show':action.show}"
              [innerHtml]="action.value | safeHtml"></div>
            }
          </div>
        }
        @for (action of wire['actions']; track action) {
          <div>
            @if (hasIWCU && action.type === 'consent_upgrade') {
              <div class="form-group consent-upgrade"
                >
                <div class="form-input">
                  <hr>
                    @if (brandingPG.name !== 'all') {
                      <p
                        class="consent-label"
                        [innerHtml]="productGroup.consent.in_wire_upgrade.ts_cs | safeHtml"
                      ></p>
                    }
                    @if (brandingPG.name === 'all') {
                      <p
                        class="consent-label"
                        ><label>Terms and Conditions will show for the user's default product group</label></p>
                      }
                      <div class="checkbox">
                        <input type="checkbox" id="upgrade_consent">
                        <label for="upgrade_consent">I accept the terms and conditions</label>
                      </div>
                      <hr>
                      </div>
                    </div>
                  }
                  @if (hasIWCU && action.type === 'consent_upgrade') {
                    <div id="step-action-{{action.id}}"
                      >
                      <span class="message-action">
                        {{action.label}}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        <div class="disclaimer">
          @if (productGroup?.disclaimer.message_details_enabled == 'true') {
            <div
              [innerHtml]="productGroup.disclaimer.text | safeHtml">
            </div>
          }
        </div>
      }
